module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"escript360","start_url":"/","background_color":"#00B4D7","theme_color":"#00B4D7","display":"minimal-ui","icon":"src/images/favicon.jpg"},
    },{
      plugin: require('../node_modules/gatsby-source-prismic-graphql/gatsby-browser.js'),
      options: {"plugins":[],"repositoryName":"escript360","path":"/preview","previews":true,"pages":[{"type":"Generic_static_page","match":"/:uid","path":"page-preview","component":"/opt/build/repo/src/templates/generic-page.js"}]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
